import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Router from "next/router";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import FormInput from "../formInput/formInput";
import { loginAsync } from "../../store/actions/auth";
import { storeAuth } from "../../store/actions/auth";
import axiosInstance from "../../config/axios";
import InlineLoading from "../../components/UI/inlineLoader";
import FacebookLoginComponent from "../FacebookLoginComponent";
import GoogleLoginComponent from "../GoogleLoginComponent";
import { useRouter } from "next/router";

const Login = () => {
  const [inlineLoader, setInlineLoader] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const router = useRouter();

  // All store
  const loadingState = useSelector((state) => state.loader.loading);
    let token = useSelector((state) => state.auth.token);
  const { register, handleSubmit, errors, reset,setValue } = useForm();
  const dispatch = useDispatch();

  const onFacebookLogin = async (data) => {
    if (data) {
      // console.log(data);
      const userData = {
        first_name: data.name.split(" ")[0],
        last_name: data.name.split(" ")[1] ? data.name.split(" ")[1] : "",
        email: data.email,
        social_media_type: data.graphDomain,
        signup_device: "web",
      };
      try {
        const {
          data: { data: response },
        } = await axiosInstance.post("social-login", userData);
        const user = {
          token: response.token,
          user: response.user,
        };
        dispatch(storeAuth(user));
        if (!response.user.phone) {
          Router.push("/");
          // Cookies.set('no-phone', 1);
        } else {
          let redirectTo = localStorage.getItem("checkoutToLogin");
          // checkoutCookies = String(checkoutCookies);
          if (redirectTo) {
            Router.push(redirectTo);
            localStorage.removeItem("checkoutToLogin");
          } else {
            Router.push("/");
          }
        }
      } catch (e) {
        // console.log(e);
      }
    } else {
      return;
    }
  };
  useEffect(() => {
    const emailFromQuery = router.query.email;
    if (emailFromQuery) {
      setValue("email", emailFromQuery); // Set email into the form
      localStorage.setItem("prefilledEmail", emailFromQuery);
    } else {
      const savedEmail = localStorage.getItem("prefilledEmail");
      if (savedEmail) {
        setValue("email", savedEmail);
      }
    }
  }, [router.query.email, setValue]);
  useEffect(() => {
    if (router.query.email) {
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  const googleLoginHandler = async (data) => {
    if (data) {
   
      const userData = {
        first_name: data.profileObj.givenName,
        last_name: data.profileObj.familyName ? data.profileObj.familyName : "",
        email: data.profileObj.email,
        social_media_type: "google",
        signup_device: "web",
        id_token: data.tokenId
      };
    
      try {
        const {
          data: { data: response },
        } = await axiosInstance.post("V1/social-login", userData);
        const user = {
          token: response.token,
          user: response.user,
          
        };
        dispatch(storeAuth(user));
        NotificationManager.success("Login successful", "", 3000);
        if (!response.user.phone) {
          Router.push("/");
          // Cookies.set('no-phone', 1);
        } else {
          let redirectTo = localStorage.getItem("checkoutToLogin");
          // checkoutCookies = String(checkoutCookies);
          if (redirectTo) {
            Router.push(redirectTo);
            localStorage.removeItem("checkoutToLogin");
          } else {
            Router.push("/");
          }
        }
      } catch (e) {
         NotificationManager.error("Login failed", "", 3000);
        // console.log(e);
      }
    } else {
      // console.log("that");
      return;
    }
  };

  const loginHandler = async (data) => {
    setInlineLoader(true);
    if (data) {
      try {
        await dispatch(loginAsync(data));
        // console.log();
        setInlineLoader(false);
      } catch (error) {
        // console.log(error);
        setInlineLoader(false);
      }
    }
    reset({});
  };

  const togglePasswordVisibility = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  return (
    <>
    
      <div className="col-md-5">
        <h3>Sign In</h3>
        <p className="mb-3">Welcome back! Sign in to your Account</p>
        <form onSubmit={handleSubmit(loginHandler)} className="signup-form">
          <FormInput
            type="email"
            name="email"
            placeholder="example@email.com*"
           
            register={register({
              required: "Please input a valid email address",
            })}
            error={errors.email && errors.email.message}
          />
          <div>
           
            <div className="textbox">
              <input
                type={passwordShown ? "text" : "password"}
                name="password"
                placeholder="Password*"
                label="Password"
                ref={register({
                  required: "Password is required",
                    minLength: {
          value: 8,
          message: "Password must be at least 8 characters",  // ← add message here
        },
                })}
              />
              <i
                onClick={togglePasswordVisibility}
                className={passwordShown ? "fa fa-eye" : "fa fa-eye-slash"}
                aria-hidden="true"
              ></i>
              <div
                className={`border ${errors.password ? "border-error" : null}`}
              ></div>
            </div>
            {errors.password && (
              <p className="error">{errors.password.message}</p>
            )}
          </div>

          <div className="d-flex align-items-center justify-content-between flex-wrap remember-account">
            <label className="contain">
              Remember me
              <input name="rememberAccount" type="checkbox" />
              <span className="checkmark"></span>
            </label>
            <div>
              <a onClick={() => Router.push("/forgot-password")}>
                Forgot Password?
              </a>
            </div>
          </div>
          {loadingState && inlineLoader ? (
            <InlineLoading />
          ) : (
            <button className="btn btn-login">
              <span className="text">Login</span>
            </button>
          )}
        </form>
        <p className="mt-3 mb-2">Or sign in with</p>
        <div className="other-signin-option">
          {/* <FacebookLoginComponent onLogin={onFacebookLogin} /> */}
          <div className="gle-btn">
            <GoogleLoginComponent onLogin={googleLoginHandler} />
          </div>
          {/* <button className="fb-btn"><img src="/images/icon/fb-white.svg" alt="" />facebook</button>
                    <button><img src="/images/icon/google.svg" alt="" />Google</button> */}
        </div>
      </div>
    </>
  );
};

export default Login;
